import {Directive, ElementRef, OnInit} from '@angular/core';

const MODAL = {
  DRAWER: 'modal-dialog-drawer',
  DIALOG: 'modal-dialog'

};

@Directive({
  selector: '[oxDrawerModal]'
})
export class DrawerModalDirective implements OnInit {

  constructor(private element: ElementRef) {
  }

  ngOnInit() {
    const parent = this.element?.nativeElement?.parentElement?.parentElement?.parentElement || null;
    function cb(observer: MutationObserver) {
      if (parent?.classList) {
        const map = new Map<string, number>();
        for (let i = 0; i < parent.classList.length; i++) {
          map.set(parent.classList[i], i);
        }
        if (map.has(MODAL.DIALOG) && map.has(MODAL.DRAWER)) {
          parent.classList.remove(MODAL.DIALOG);
          observer.disconnect();
        }
      }
    }
    new MutationObserver((mutations, observer) => {
      mutations.forEach((mutation) => (mutation.type === 'attributes' && mutation.attributeName === 'class') ? cb(observer) : null);
    }).observe(parent, {attributes: true});
  }

}
